import { useSyncExternalStore } from "react";
import { sfxCore } from "@/lib/celebrate";

const KEY = "itz_music_on";
const LEVEL = 0.22;
const BPM = 122;
const STEP = 60 / BPM / 4;
// A-Moll: Am – F – Dm – E (spannend, treibend)
const CHORDS = [[57, 60, 64], [53, 57, 60], [50, 53, 57], [52, 56, 59]];
const ARP = [0, 1, 2, 1, 0, 2, 1, 2, 0, 1, 2, 1, 2, 1, 0, 2];
const hz = (m) => 440 * 2 ** ((m - 69) / 12);

const subs = new Set();
export const musicOn = () => localStorage.getItem(KEY) !== "0";
export const setMusicOn = (v) => { localStorage.setItem(KEY, v ? "1" : "0"); subs.forEach((f) => f()); };
export const useMusicOn = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, musicOn);

let a = null, bus = null, timer = null, step = 0, next = 0, noiseBuf = null;

const voice = (t, freq, dur, type, vol, cutoff) => {
  const o = a.createOscillator(), fl = a.createBiquadFilter(), g = a.createGain();
  o.type = type; o.frequency.setValueAtTime(freq, t);
  fl.type = "lowpass"; fl.frequency.setValueAtTime(cutoff, t);
  g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol, t + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(fl).connect(g).connect(bus); o.start(t); o.stop(t + dur + 0.05);
};
const kick = (t) => {
  const o = a.createOscillator(), g = a.createGain();
  o.frequency.setValueAtTime(130, t); o.frequency.exponentialRampToValueAtTime(42, t + 0.16);
  g.gain.setValueAtTime(0.5, t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.2);
  o.connect(g).connect(bus); o.start(t); o.stop(t + 0.25);
};
const hat = (t, vol) => {
  if (!noiseBuf) { noiseBuf = a.createBuffer(1, a.sampleRate * 0.05, a.sampleRate); const d = noiseBuf.getChannelData(0); for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1; }
  const s = a.createBufferSource(), fl = a.createBiquadFilter(), g = a.createGain();
  s.buffer = noiseBuf; fl.type = "highpass"; fl.frequency.value = 7000;
  g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.04);
  s.connect(fl).connect(g).connect(bus); s.start(t);
};

const schedule = (s, t) => {
  const bar = Math.floor(s / 16) % 4, i = s % 16, ch = CHORDS[bar], sweep = 900 + (s % 64) * 28;
  if (i % 2 === 0) voice(t, hz(ch[0] - 24), STEP * 1.7, "sawtooth", 0.12, 320);
  voice(t, hz(ch[ARP[i]] + (i >= 8 ? 12 : 0)), STEP * 0.85, "square", 0.028, sweep);
  if (i === 0) voice(t, hz(ch[2] + 12), STEP * 15, "triangle", 0.035, 1400);
  if (i % 4 === 0) kick(t);
  if (i % 4 === 2) hat(t, 0.05);
  else if (i % 2 === 1) hat(t, 0.018);
};

const tick = () => {
  if (a.state !== "running") return;
  if (next < a.currentTime) next = a.currentTime + 0.05;
  while (next < a.currentTime + 0.15) { schedule(step, next); next += STEP; step = (step + 1) % 64; }
};

const unlock = () => { if (timer) sfxCore.audio(); };

export const startMusic = () => {
  if (timer) return;
  a = sfxCore.audio();
  if (!a) return;
  bus = a.createGain();
  bus.gain.setValueAtTime(0.0001, a.currentTime);
  bus.gain.exponentialRampToValueAtTime(LEVEL, a.currentTime + 2.5);
  bus.connect(sfxCore.out(a));
  next = 0; step = 0;
  timer = setInterval(tick, 40);
  window.addEventListener("pointerdown", unlock);
};

export const stopMusic = () => {
  if (!timer) return;
  clearInterval(timer); timer = null;
  window.removeEventListener("pointerdown", unlock);
  const g = bus, t = a.currentTime;
  g.gain.cancelScheduledValues(t); g.gain.setValueAtTime(Math.max(0.0001, g.gain.value), t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.6);
  setTimeout(() => g.disconnect(), 800);
};
